import CompareListItem from './CompareListItem';

export default CompareListItem;
